// Core
import { Routes } from '@angular/router';

// Pages
import { IndexPage } from './pages/index-page/index-page';
import { PrivacyPolicyPage } from './pages/privacy-policy-page/privacy-policy-page';
import { TermsOfServicePage } from './pages/terms-of-service-page/terms-of-service-page';

export const routes: Routes = [
    { path: '', component: IndexPage },
    { path: 'privacy-policy', component: PrivacyPolicyPage },
    { path: 'terms-of-service', component: TermsOfServicePage }
];
